// Export the Component Definition for use in Contentful Studio
export {ActionBlockCollectionContentfulComponentDefinition} from './ActionBlockCollectionContentfulDefinition';
export {default} from './ActionBlockCollection';
